import { intComma } from 'humanize-plus'

export const CUBE_QUERY_MAX_LIMIT = 10
export const CUBE_QUERY_MAX_INFO = `The export maximum is ${intComma(
  CUBE_QUERY_MAX_LIMIT
)} records`

export const CubeSchemaTables = {
  APP_USERS: 'DriftChatAppUsers',
  CONVERSATIONS: 'FACTDriftChatConversationV2',
  END_USERS: 'DriftChatEndUsers',
  APP_USERS_ONLY_FIRST_DRIFT_USER: 'DriftChatAppUsersOnlyFirstDriftUser',
  CONVERSATION_TAGS: 'DriftChatTags',
  MEETINGS: 'DriftChatSchedulingEvents',
  CLASSIFICATIONS: 'DriftChatClassifications',
  INBOXES: 'DriftChatInboxes',
  CONVERSATION_ROUTING: 'DriftChatConversationRouting',
  PLAYBOOKS: 'DriftChatPlaybooks',
  WIDGET_IMPRESSIONS: 'DriftChatWidgetImpressions',
  WIDGET_IMPRESSIONS_BY_MINUTES: 'DriftChatImpressionsByMinute',
  DRIFT_CHAT_BLENDED_PLAYBOOK_METRICS: 'DriftChatBlendedPlaybookMetrics',
  PLAYBOOK_OUTCOMES: 'DriftChatPlaybookOutcomes',
  INTERACTIONS: 'DriftChatInteractions',
  PLAYBOOK_EVENTS: 'DriftChatPlaybookEvents',
  TAGS: 'DriftChatTags',
  DRIFT_CHAT_SKILL_EXECUTIONS: 'DriftChatSkillExecutions',
  DRIFT_CHAT_BUYER_SENTIMENT: 'DriftChatConversationSentiment',
  DRIFT_CHAT_CONVERSATION_RATINGS: 'DriftChatConversationRatings',
  DRIFT_CHAT_OPPORTUNITY_OVERVIEW: 'DriftChatOpportunityOverview',
  DRIFT_CHAT_OPPORTUNITY_ACTIVITIES: 'DriftChatOpportunityActivities',
  DRIFT_CHAT_OPPORTUNITY_EVENTS: 'DriftChatOpportunityEvents',
  DRIFT_SITE_CONCIERGE: 'DriftSiteConcierge',
  DRIFT_CHAT_BIONIC_RATABLE_MESSAGES: 'DriftChatBionicRatableMessages',
  DRIFT_CHAT_SCENARIO_EXECUTIONS: 'DriftChatScenarioExecutions',
  DRIFT_CHAT_BIONIC_RATED_MESSAGES: 'DriftChatBionicRatedMessages',
} as const

export const DRIFT_CHAT_END_USERS_DIMENSIONS = {
  NAME: 'DriftChatEndUsers.name',
  DISPLAY_NAME: 'DriftChatEndUsers.displayName',
  COUNTRY_CODE: 'DriftChatEndUsers.geoCountryCode',
  GEO_REGION: 'DriftChatEndUsers.geoRegion',
  GEO_CITY: 'DriftChatEndUsers.geoCity',
  EMAIL: 'DriftChatEndUsers.email',
  PHONE: 'DriftChatEndUsers.phone',
  COMPANY_NAME: 'DriftChatEndUsers.companyName',
  COMPANY_AVATAR_URL: 'DriftChatEndUsers.companyAvatarUrl',
  AVATAR_URL: 'DriftChatEndUsers.avatarUrl',
}

/**
 * Zone dimensions are dates returned from the database converted into the user's timezone
 *
 * @docs https://github.com/Driftt/cube-reporting-schemas/blob/master/README.md#inconsistent-timezone-handling
 */
export const CONVERSATION_FACTS_ZONE_DIMENSIONS = {
  CONVERSATION_CREATED_AT:
    'FACTDriftChatConversationV2.conversationCreatedAtWithZone',
  CONVERSATION_CLOSE_AT:
    'FACTDriftChatConversationV2.firstConversationCloseAtWithZone',
  FIRST_USER_INTERACTION_AT:
    'FACTDriftChatConversationV2.firstDriftuserInteractionAtWithZone',
}

export const CONVERSATION_FACTS_DIMENSIONS = {
  CONVERSATION_CREATED_AT: 'FACTDriftChatConversationV2.conversationCreatedAt',
  CONVERSATION_UPDATED_AT: 'FACTDriftChatConversationV2.conversationUpdatedAt',
  END_USER_INTERACCTION_MESSAGE_ID:
    'FACTDriftChatConversationV2.firstEnduserInteractionMessageId',
  HAS_MEETING_BOOKED: 'FACTDriftChatConversationV2.hasMeetingBooked',
  HAS_EMAIL_CAPTURED: 'FACTDriftChatConversationV2.hasEmailCaptured',
  HAS_PHONE_CAPTURED: 'FACTDriftChatConversationV2.hasPhoneCaptured',
  IS_TESTING_CONVERSATION: 'FACTDriftChatConversationV2.isTestingConversation',
  HOUR_OF_DAY: 'FACTDriftChatConversationV2.hourOfDay',
  DAY_OF_WEEK: 'FACTDriftChatConversationV2.dayOfWeek',
  CONVERSATION_CREATED_FROM_URL:
    'FACTDriftChatConversationV2.conversationCreatedFromUrl',
  DURATION_BETWEEN_FIRST_INTERACTION_AND_FIRST_CLOSE_MS:
    'FACTDriftChatConversationV2.durationBetweenFirstInteractionAndFirstCloseMillis',
  DURATION_BETWEEN_FIRST_INTERACTION_AND_FIRST_CLOSE_FORMATTED:
    'FACTDriftChatConversationV2.durationBetweenFirstInteractionAndFirstCloseFormatted',
  CONVERSATION_ID: 'FACTDriftChatConversationV2.conversationId',
  PLAYBOOK_ID: 'FACTDriftChatConversationV2.playbookId',
  INBOX_ID: 'FACTDriftChatConversationV2.inboxId',
  PARTICIPANT_STATUS: 'FACTDriftChatConversationV2.participantStatus',
  CONVERSATION_CLOSE_AT: 'FACTDriftChatConversationV2.firstConversationCloseAt',
  END_USER_ID: 'FACTDriftChatConversationV2.enduserId',
  AGENT_FIRST_REPSONSE_TIME:
    'FACTDriftChatConversationV2.firstDriftuserInteractionAt',
  CQL_SCORE: 'FACTDriftChatConversationV2.cqlScore',
  LAST_CLASSIFICATION_ID: 'FACTDriftChatConversationV2.lastClassificationId',
  CONVERSATION_STATUS: 'FACTDriftChatConversationV2.conversationStatus',
  CONVERSATION_APP_URL: 'FACTDriftChatConversationV2.conversationDriftAppUrl',
  END_USER_LAST_RESPONSE_TIME:
    'FACTDriftChatConversationV2.lastEnduserInteractionAt',
  AGENT_LAST_RESPONSE_TIME:
    'FACTDriftChatConversationV2.lastDriftuserInteractionAt',
  FIRST_CONVERSATION_CLOSE_TYPE:
    'FACTDriftChatConversationV2.firstConversationCloseType',
  CHAT_INTERACTION_COUNT: 'FACTDriftChatConversationV2.chatInteractionCount',
} as const

export const DRIFT_APP_USER_FIRST_IN_CONVERSATION = {
  USER_ID: 'DriftChatAppUsersOnlyFirstDriftUser.userId',
  NAME: 'DriftChatAppUsersOnlyFirstDriftUser.name',
  DISPLAY_NAME: 'DriftChatAppUsersOnlyFirstDriftUser.displayName',
}

export const DRIFT_APP_USER_LAST_IN_CONVERSATION = {
  USER_ID: 'DriftChatAppUsersOnlyLastDriftUser.userId',
  DISPLAY_NAME: 'DriftChatAppUsersOnlyLastDriftUser.displayName',
  LAST_USER_AVATAR_URL: 'DriftChatAppUsersOnlyLastDriftUser.avatarUrl',
}

export const CONVERSATION_FACTS_MEASURES = {
  MEDIAN_DURATION_BETWEEN_FIRST_INTERACTION_AND_FIRST_CLOSE_SECONDS:
    'FACTDriftChatConversationV2.medianDurationBetweenFirstInteractionAndFirstCloseSeconds',
  CONVERSATION_COUNT: 'FACTDriftChatConversationV2.count',
  CONVERSATION_ID: 'FACTDriftChatConversationV2.conversationId',
  EMAIL_CAPTURED_COUNT: 'FACTDriftChatConversationV2.countEmailCaptured',
  MEETINGS_BOOKED_COUNT: 'FACTDriftChatConversationV2.countMeetingBooked',
}

export const MEETINGS_USERS_DIMENSIONS = {
  ORG_ID: 'DriftChatAppUsers.orgId',
  AGENT_ID: 'DriftChatAppUsers.userId',
  AGENT_EMAIL: 'DriftChatAppUsers.emailAddress',
  AGENT_NAME: 'DriftChatAppUsers.displayName',
  END_USER_ID: 'DriftChatEndUsers.endUserId',
  END_USER_EMAIL: 'DriftChatEndUsers.email',
  END_USER_NAME: 'DriftChatEndUsers.name',
  END_USER_COMPANY: 'DriftChatEndUsers.company',
  END_USER_TITLE: 'DriftChatEndUsers.title',
  END_USER_COMPANY_NAME: 'DriftChatEndUsers.companyName',
  END_USER_COMPANY_EMPLOYMENT_TITLE: 'DriftChatEndUsers.companyEmploymentTitle',
  END_USER_AVATAR_URL: 'DriftChatEndUsers.avatarUrl',
  ROLE: 'DriftChatAppUsers.role',
}

export const MEETINGS_DIMENSIONS = {
  SCHEDULED_AT: 'DriftChatSchedulingEvents.schedulingEventScheduledAt',
  EVENT_ID: 'DriftChatSchedulingEvents.eventId',
  MEETING_SOURCE: 'DriftChatSchedulingEvents.meetingSource',
  START_AT: 'DriftChatSchedulingEvents.schedulingEventSlotStartAt',
  END_AT: 'DriftChatSchedulingEvents.schedulingEventSlotEndAt',
  STATUS: 'DriftChatSchedulingEvents.status',
  BOOKED_BY: 'DriftChatSchedulingEvents.bookedByUserId',
}

export const MEETINGS_MEASURES = {
  MEETING_COUNT: 'DriftChatSchedulingEvents.count',
}

export const DRIFT_CHAT_TAGS_DIMENSIONS = {
  TAG_NAME: 'DriftChatTags.name',
}

export const DRIFT_CHAT_TAGS_MEASURES = {
  NAME_ROLLUP: 'DriftChatTags.nameRollup',
}

export const DRIFT_CHAT_SKILL_EXECUTIONS_MEAURES = {
  SKILL_TYPE_ROLLUP: 'DriftChatSkillExecutions.skillTypeRollup',
}

export const DRIFT_CHAT_BUYER_SENTIMENT_MEASURES = {
  BUYER_SENTIMENT: 'DriftChatConversationSentiment.overallBuyerSentiment',
}

export const DRIFT_CHAT_PLAYBOOK_DIMENSIONS = {
  PLAYBOOK_NAME: 'DriftChatPlaybooks.name',
  PLAYBOOK_STATUS: 'DriftChatPlaybooks.status',
  PLAYBOOK_AI_ENABLED: 'DriftChatPlaybooks.isAiEnabled',
  PLAYBOOK_IS_GPT_ENABLED: 'DriftChatPlaybooks.isGPTEnabled',
}

export const DRIFT_CHAT_TEAMS_DIMENSIONS = {
  TEAM_ID: 'DriftChatTeams.teamId',
  TEAM_NAME: 'DriftChatTeams.name',
  TEAM_STATUS: 'DriftChatTeams.status',
}

export const DRIFT_CHAT_APP_USERS_DIMENSIONS = {
  DISPLAY_NAME: 'DriftChatAppUsers.displayName',
  USER_ID: 'DriftChatAppUsers.userId',
  STATUS: 'DriftChatAppUsers.status',
  AVATAR_URL: 'DriftChatAppUsers.avatarUrl',
  NAME: 'DriftChatAppUsers.name',
}

export const DRIFT_CHAT_APP_USERS_MEASURES = {
  NAME_ROLLUP: 'DriftChatAppUsers.nameRollup',
}

export const DRIFT_CHAT_TEAM_USERS_DIMENSIONS = {
  TEAM_ID: 'DriftChatTeamUsers.teamId',
}

export const DRIFT_CHAT_CLASSIFICATIONS_DIMENSIONS = {
  CLASSIFICATION_NAME: 'DriftChatClassifications.name',
}

export const DRIFT_CHAT_INBOX_DIMENSIONS = {
  NAME: 'DriftChatInboxes.name',
  ID: 'DriftChatInboxes.inboxId',
  STATUS: 'DriftChatInboxes.status',
}

export const DRIFT_CHAT_CONVERSATION_ROUTING_DIMENSIONS = {
  CONVERSATION_ID: 'DriftChatConversationRouting.conversationId',
  IS_DEAD_END: 'DriftChatConversationRouting.isDeadEnd',
  HAS_CALENDAR_DROP: 'DriftChatConversationRouting.hasCalendarDrop',
  HAS_TICKET_CREATED: 'DriftChatConversationRouting.hasTicketCreated',
  INITIAL_ROUTED_IN_USERID:
    'DriftChatConversationRouting.initialRoutedInUserId',
  HAS_TEAMMATE_ROUTED_IN: 'DriftChatConversationRouting.hasTeammateRoutedIn',
  HAS_TEAMMATE_RESPONDED: 'DriftChatConversationRouting.hasTeammateResponded',
  HAS_ROUTED_AND_SOMEONE_RESPONDED_WITHIN_60S:
    'DriftChatConversationRouting.hasRoutedAndSomeoneRespondedWithin60s',
  HAS_ROUTED_AND_EVERYONE_MISSED:
    'DriftChatConversationRouting.hasRoutedAndEveryoneMissed',
  ROUTING_OUTCOME: 'DriftChatConversationRouting.routingOutcome',
  TIME_TO_FIRST_RESPONSE_FORMATTED:
    'DriftChatConversationRouting.timeToFirstResponseFormatted',
  TIME_TO_FIRST_RESPONSE_MS:
    'DriftChatConversationRouting.timeToFirstResponseMs',
  TIME_FIRST_ROUTED_AT_WITH_ZONE:
    'DriftChatConversationRouting.firstRoutedAtWithZone',
  TIME_FIRST_ROUTED_DRIFT_USER_RESPONDED_AT_WITH_ZONE:
    'DriftChatConversationRouting.firstRoutedDriftUserRespondedAtWithZone',
}

export const DRIFT_CHAT_SKILL_EXECUTIONS_DIMENSIONS = {
  SKILL_TYPE: 'DriftChatSkillExecutions.skillType',
}

export const DRIFT_CHAT_CONVERSATION_ROUTING_MEASURES = {
  AVERAGE_TIME_TO_FIRST_RESPONSE:
    'DriftChatConversationRouting.averageTimeToFirstResponseS',
  COUNT_FALLBACK_ACTION:
    'DriftChatConversationRouting.countRoutingFallbackAction',
  AVERAGE_TIME_TO_FIRST_ROUTED_USER_RESPONSE:
    'DriftChatConversationRouting.averageTimeToFirstRoutedUserResponse',
  COUNT_CONVOS_WITH_UNRESPONSIVE_FALLBACK_EVENTS:
    'DriftChatConversationRouting.countConversationsWithUnresponsiveFallbackEvents',
  COUT_TEAMMATE_ROUTED_AND_RESPONDED:
    'DriftChatConversationRouting.countTeammateRoutedInAndResponded',
}

export const ROUTING_SANKEY_MEASURES = {
  ROUTING_REQUEST_TO_TEAMMATE_ROUTED_IN:
    'DriftChatConversationRouting.countRoutingRequestToTeammateRoutedIn',
  ROUTING_REQUEST_TO_TEAMMATE_NOT_ROUTED_IN:
    'DriftChatConversationRouting.countRoutingRequestToTeammateNotRoutedIn',
  TEAMMATE_ROUTED_IN_TO_RESPONDED_WITHIN60S:
    'DriftChatConversationRouting.countTeammateRoutedInToRespondedWithin60s',
  TEAMMATE_ROUTED_IN_TO_MISSED:
    'DriftChatConversationRouting.countTeammateRoutedInToMissed',
  MISSED_TO_RESPONSE_LATE:
    'DriftChatConversationRouting.countMissedToResponseLate',
  MISSED_TO_NEVER_RESPONDED:
    'DriftChatConversationRouting.countMissedToNeverResponded',
  TEAMMATE_NOT_ROUTED_IN_TO_TEAMMATES_WERE_UNAVAILABLE:
    'DriftChatConversationRouting.countTeammateNotRoutedInToTeammatesWereUnavailable',
  RESPONDED_WITHIN60S_TO_TEAMMATE_RESPONDED:
    'DriftChatConversationRouting.countRespondedWithin60sToTeammateResponded',
  RESPONDED_LATE_TO_TEAMMATE_RESPONDED:
    'DriftChatConversationRouting.countRespondedLateToTeammateResponded',
  NEVER_RESPONDED_TO_AWAY_MESSAGE_SENT:
    'DriftChatConversationRouting.countNeverRespondedToAwayMessageSent',
  TEAMMATES_WERE_UNAVAILABLE_TO_AWAY_MESSAGE_SENT:
    'DriftChatConversationRouting.countTeammatesWereUnavailableToAwayMessageSent',
  NEVER_RESPONDED_TO_CALENDAR_DROPPED:
    'DriftChatConversationRouting.countNeverRespondedToCalendarDropped',
  TEAMMATES_WERE_UNAVAILABLE_TO_CALENDAR_DROPPED:
    'DriftChatConversationRouting.countTeammatesWereUnavailableToCalendarDropped',
  NEVER_RESPONDED_TO_TICKET_CREATED:
    'DriftChatConversationRouting.countNeverRespondedToTicketCreated',
  TEAMMATES_WERE_UNAVAILABLE_TO_TICKET_CREATED:
    'DriftChatConversationRouting.countTeammatesWereUnavailableToTicketCreated',
  NEVER_RESPONDED_TO_DEAD_END:
    'DriftChatConversationRouting.countNeverRespondedToDeadEnd',
  TEAMMATES_WERE_UNAVAILABLE_TO_DEAD_END:
    'DriftChatConversationRouting.countTeammatesWereUnavailableToDeadEnd',
  TEAMMATES_WERE_UNAVAILABLE_TO_TEAMMATE_RESPONDED:
    'DriftChatConversationRouting.countTeammatesWereUnavailableToTeammateResponded',
}

export const ROUTING_MEASURES = {
  ...ROUTING_SANKEY_MEASURES,
  ROUTING_COUNT: 'DriftChatConversationRouting.count',
  RESPONSE_COUNT: 'DriftChatConversationRouting.countResponse',
  DEAD_END_COUNT: 'DriftChatConversationRouting.countDeadEnd',
  MEDIAN_TIME_TO_FIRST_RESPONSE:
    'DriftChatConversationRouting.medianTimeToFirstResponseS',
}

export const CHAT_IMPRESSIONS_MEASURES = {
  CHAT_IMPRESSION_COUNT: 'DriftChatWidgetImpressions.count',
  CHAT_IMPRESSIONS_BY_MINUTES_COUNT:
    'DriftChatImpressionsByMinute.countImpressions',
  CHAT_IMPRESSIONS_BY_MINUTES_SENDS_COUNT:
    'DriftChatImpressionsByMinute.countSends',
  CHAT_IMPRESSION_SENDS: 'DriftChatWidgetImpressions.sends',
  CHAT_IMPRESSION_SENT_AT: 'DriftChatWidgetImpressions.impressionSentAt',
  CHAT_IMPRESSIONS_PLAYBOOK_ID: 'DriftChatWidgetImpressions.playbookId',
  CHAT_IMPRESSIONS_RECEIVED_AT:
    'DriftChatWidgetImpressions.impressionReceivedAt',
  CHAT_IMPRESSIONS_BY_MINUTES_RECEIVED_AT:
    'DriftChatImpressionsByMinute.receivedAtMinute',
}

export const PLAYBOOKS_CHAT_DIMENSIONS = {
  PLAYBOOK_ID: 'DriftChatPlaybooks.playbookId',
  PLAYBOOK_NAME: 'DriftChatPlaybooks.name',
  PLAYBOOK_STATUS: 'DriftChatPlaybooks.status',
  PLAYBOOK_CREATED_AT: 'DriftChatPlaybooks.createdAt',
  PLAYBOOK_REPORT_TYPE: 'DriftChatPlaybooks.reportType',
  PLAYBOOK_WORKSPACE_ID: 'DriftChatPlaybooks.workspaceId',
  PLAYBOOK_IS_AI_ENABLED: 'DriftChatPlaybooks.isAiEnabled',
}

export const DRIFT_CHAT_CONVERSATIONS_RATINGS_MEASURES = {
  RATING_AVERAGE: 'DriftChatConversationRatings.average',
}

export const DRIFT_CHAT_CONVERSATIONS_RATINGS_DIMENSIONS = {
  CSAT_RATING: 'DriftChatConversationRatings.ratingValue',
  CSAT_RATING_TEXT: 'DriftChatConversationRatings.ratingText',
}

export const DRIFT_CHAT_APP_USERS_ONLY_FIRST_ROUTED_USER_DIMENSIONS = {
  DISPLAY_NAME: 'DriftChatAppUsersOnlyFirstRouted.displayName',
  AVATAR_URL: 'DriftChatAppUsersOnlyFirstRouted.avatarUrl',
  USER_ID: 'DriftChatAppUsersOnlyFirstRouted.userId',
}

export const DRIFT_CHAT_BLENDED_PLAYBOOK_METRICS_MEASURES = {
  COUNT_IMPRESSIONS: 'DriftChatBlendedPlaybookMetrics.countImpressions',
  COUNT_SENDS: 'DriftChatBlendedPlaybookMetrics.countSends',
  COUNT_CONVERSATIONS: 'DriftChatBlendedPlaybookMetrics.countConversations',
  COUNT_EMAILS_CAPTURED: 'DriftChatBlendedPlaybookMetrics.countEmailsCaptured',
  COUNT_MEETINGS_BOOKED: 'DriftChatBlendedPlaybookMetrics.countMeetingsBooked',
  COUNT_ROUTED_CONVERSATIONS:
    'DriftChatBlendedPlaybookMetrics.countRoutedConversations',
  AVG_CQL_SCORE: 'DriftChatBlendedPlaybookMetrics.avgCQLScore',
  SUM_CQL_SCORE: 'DriftChatBlendedPlaybookMetrics.sumCQLScore',
}

export const DRIFT_CHAT_BLENDED_PLAYBOOK_METRICS_DIMENSIONS = {
  ORG_ID: 'DriftChatBlendedPlaybookMetrics.orgId',
  PLAYBOOK_ID: 'DriftChatBlendedPlaybookMetrics.playbookId',
  PLAYBOOK_VERSION: 'DriftChatBlendedPlaybookMetrics.playbookVersion',
  METRIC_AT: 'DriftChatBlendedPlaybookMetrics.metricAt',
  BOT_FLOW: 'DriftChatBlendedPlaybookMetrics.botFlow',
  BYPASS_PREAGG: 'DriftChatBlendedPlaybookMetrics.bypassPreagg',
}

export const DRIFT_SITE_CONCIERGE_MEASURES = {
  COUNT_CONTENT_PREVIEWS: 'DriftSiteConcierge.countContentPreviews',
  COUNT_CONTENT_CLICKS: 'DriftSiteConcierge.countContentClicks',
  COUNT_SC_LOADS: 'DriftSiteConcierge.countLoads',
}

export const DRIFT_SITE_CONCIERGE_DIMENSIONS = {
  ORG_ID: 'DriftSiteConcierge.orgId',
  URL: 'DriftSiteConcierge.url',
  EVENT_SENT_AT: 'DriftSiteConcierge.eventSentAt',
  EVENT_SENT_AT_WITH_ZONE: 'DriftSiteConcierge.eventSentAtWithZone',
  EVENT_NAME: 'DriftSiteConcierge.eventName',
  ACTION: 'DriftSiteConcierge.action',
}

export const DRIFT_SITE_CONCIERGE_SEARCH_MEASURES = {
  COUNT_LOADS: 'DriftSiteConcierge.countLoads',
  COUNT_SEARCH_BUTTON_CLICKS: 'DriftSiteConcierge.searchButtonClicks',
  COUNT_SEARCHES_PERFORMED: 'DriftSiteConcierge.searchesPerformed',
  COUNT_SOURCE_CLICK_THROUGHS: 'DriftSiteConcierge.sourceClickThroughs',
}

export const DRIFT_SITE_CONCIERGE_SEARCH_DIMENSIONS = {
  SEARCH_QUERY: 'DriftSiteConcierge.searchQuery',
  SEARCH_IS_GENERATED: 'DriftSiteConcierge.searchIsGenerated',
  SEARCH_MESSAGE_ID: 'DriftSiteConcierge.searchMessageId',
  SEARCH_RESULT: 'DriftSiteConcierge.searchResult',
}

export const DRIFT_SITE_CONCIERGE_MEETINGS_MEASURES = {
  COUNT_SC_LOADS: 'DriftSiteConcierge.countLoads',
  COUNT_MEETING_APP_LOADS: 'DriftSiteConcierge.countMeetingsAppLoads',
  COUNT_MEETING_BUTTON_CLICKS: 'DriftSiteConcierge.meetingButtonClicks',
}

export const PLAYBOOK_OUTCOMES_DIMENSIONS = {
  OUTCOME_EVENT_TYPE: 'DriftChatPlaybookOutcomes.outcomeEventType',
  END_USER_ID: 'DriftChatPlaybookOutcomes.enduserId',
  HAS_MEETING_BOOKED: 'DriftChatPlaybookOutcomes.hasMeetingBooked',
  HAS_CONVERSATION_HELD: 'DriftChatPlaybookOutcomes.hasConversationHeld',
  OUTCOME_UPDATED_AT: 'DriftChatPlaybookOutcomes.outcomeUpdatedAt',
  PLAYBOOK_ID: 'DriftChatPlaybookOutcomes.playbookId',
  CONVERSATION_ID: 'DriftChatPlaybookOutcomes.conversationId',
}

export const DRIFT_CHAT_INTERACTIONS_DIMENSIONS = {
  MESSAGE_BODY: 'DriftChatInteractions.messageBody',
}

export const DRIFT_CHAT_PLAYBOOK_EVENTS_DIMENSIONS = {
  PLAYBOOK_ID: 'DriftChatPlaybookEvents.playbookId',
  EVENT_TYPE: 'DriftChatPlaybookEvents.eventType',
  EVENT_CREATED_AT: 'DriftChatPlaybookEvents.eventCreatedAt',
  EVENT_ID: 'DriftChatPlaybookEvents.eventId',
  COUNT_FORMFILLS: 'DriftChatPlaybookEvents.countFormfills',
  COUNT_SENT: 'DriftChatPlaybookEvents.countSent',
  COUNT_END_USER_ENGAGED: 'DriftChatPlaybookEvents.countEndUserEngaged',
  COUNT_CONVERSATION_HELD: 'DriftChatPlaybookEvents.countConversationHeld',
  COUNT_MEETING_BOOKED: 'DriftChatPlaybookEvents.countMeetingBooked',
  MAX_EVENTS: 'DriftChatPlaybookEvents.maxEvents',
}

export const DRIFT_CHAT_PLAYBOOK_EVENTS_METRICS = {
  COUNT_END_USER_ENGAGED: 'DriftChatPlaybookEvents.countEndUserEngaged',
  COUNT_SENT: 'DriftChatPlaybookEvents.countSent',
  COUNT_CONVERSATION_HELD: 'DriftChatPlaybookEvents.countConversationHeld',
  COUNT_FORM_FILLS: 'DriftChatPlaybookEvents.countFormfills',
  COUNT_MEETINGS_BOOKED: 'DriftChatPlaybookEvents.countMeetingBooked',
  COUNT_DISMISSED: 'DriftChatPlaybookEvents.countDismissed',
}

export const FACT_DRIFT_CHAT_CONVERSATION_DIMENSIONS = {
  IS_IN_PLAYBOOK_EXPERIMENT:
    'FACTDriftChatConversationV2.isInPlaybookExperiment',
  PLAYBOOK_VERSION: 'FACTDriftChatConversationV2.playbookVersion',
}

export const DRIFT_CHAT_CONVERSATION_CLICKED_DIMENSIONS = {
  PLAYBOOK_ID: 'DriftChatConversationClicked.playbookId',
  CONVERSATION_ID: 'DriftChatConversationClicked.conversationId',
  CLICKED_AT: 'DriftChatConversationClicked.clickedAt',
  HAS_CLICKED: 'DriftChatConversationClicked.hasClicked',
  END_USER_ID: 'DriftChatConversationClicked.enduserId',
}

export const DRIFT_CHAT_SERVICE_CONVERSATIONS_MEASURES = {
  COUNT_SERVICE_CONVERSATIONS:
    'DriftChatServiceConversations.countServiceConversations',
  COUNT_DEFLECTED_CONVERSATIONS:
    'DriftChatServiceConversations.countDeflectedConversations',
}

export const DRIFT_CHAT_SERVICE_CONVERSATIONS_DIMENSIONS = {
  ORG_ID: 'DriftChatServiceConversations.orgId',
  PLAYBOOK_ID: 'DriftChatServiceConversations.playbookId',
  CONVERSATION_ID: 'DriftChatServiceConversations.conversationId',
  CONVERSATION_UPDATED_AT:
    'DriftChatServiceConversations.conversationUpdatedAt',
  IS_SERVICE_CONVERSATION:
    'DriftChatServiceConversations.isServiceConversation',
  SERVICE_REASON: 'DriftChatServiceConversations.serviceReason',
  IS_DEFLECTED_CONVERSATION:
    'DriftChatServiceConversations.isDeflectedConversation',
  NON_DEFLECTION_REASON: 'DriftChatServiceConversations.nonDeflectionReason',
}

export const DRIFT_CHAT_SERVICE_PLAYBOOKS_DIMENSIONS = {
  PLAYBOOK_ID: 'DriftChatServicePlaybooks.playbookId',
  ORG_ID: 'DriftChatServicePlaybooks.orgId',
  PLAYBOOK_SUPPORT_STATUS: 'DriftChatServicePlaybooks.playbookSupportStatus',
  IS_SERVICE_PLAYBOOK: 'DriftChatServicePlaybooks.isServicePlaybook',
}

export const DRIFT_CHAT_USERS_AVAILABILITY_BUCKETS = {
  DISPLAY_NAME: 'DriftChatAppUsers.displayName',
  BUCKET_SUM: 'DriftChatUserAvailabilityBuckets.bucketSum',
  USER_ID: 'DriftChatUserAvailabilityBuckets.userId',
  AVAILABILITY_START_AT_WITH_ZONE:
    'DriftChatUserAvailabilityBuckets.availabilityStartAtWithZone',
  AVAILABILITY_END_AT_WITH_ZONE:
    'DriftChatUserAvailabilityBuckets.availabilityEndAtWithZone',
  AVAILABILITY_BUCKET_START_AT:
    'DriftChatUserAvailabilityBuckets.availabilityBucketStartAt',
}

export const DRIFT_CHAT_TOPICS = {
  TOPIC_NAME: 'DriftChatTopics.topicName',
  TOPIC_ID: 'DriftChatTopics.topicId',
}

export const DRIFT_CHAT_TOPIC_PREDICTIONS = {
  TOPIC_ID: 'DriftChatConversationTopicPredictions.topicId',
  TOPIC_LABEL: 'DriftChatConversationTopicPredictions.predictionLabel',
}

export const DRIFT_CHAT_CONVERSATION_URL_PARAMETERS = {
  COUNT: 'DriftChatConversationUrlParameters.count',
}

export const DRIFT_CHAT_OPPORTUNITY_OVERVIEW = {
  SUM_AMOUNT: 'DriftChatOpportunityOverview.sum',
  OPPORTUNITY_ID: 'DriftChatOpportunityOverview.opportunityId',
  ORG_ID: 'DriftChatOpportunityOverview.orgId',
  OPPORTUNITY_DOMAIN: 'DriftChatOpportunityOverview.opportunityDomain',
  COMPANY_NAME: 'DriftChatOpportunityOverview.companyName',
  OPPORTUNITY_ACCOUNT_ID: 'DriftChatOpportunityOverview.opportunityAccountId',
  OPPORTUNITY_NAME: 'DriftChatOpportunityOverview.opportunityName',
  OPPORTUNITY_AMOUNT: 'DriftChatOpportunityOverview.opportunityAmount',
  OPPORTUNITY_CURRENCY: 'DriftChatOpportunityOverview.opportunityCurrency',
  OPPORTUNITY_TYPE: 'DriftChatOpportunityOverview.opportunityType',
  OPPORTUNITY_STAGE: 'DriftChatOpportunityOverview.opportunityStage',
  CONVERSATION_COUNT: 'DriftChatOpportunityOverview.conversationCount',
  CONTACT_COUNT: 'DriftChatOpportunityOverview.contactCount',
  IS_SOURCED: 'DriftChatOpportunityOverview.isSourced',
  IS_INFLUENCED: 'DriftChatOpportunityOverview.isInfluenced',
  OPPORTUNITY_CREATED_AT: 'DriftChatOpportunityOverview.opportunityCreatedAt',
  OPPORTUNITY_CLOSED_AT: 'DriftChatOpportunityOverview.opportunityClosedAt',
  OPPORTUNITY_CREATED_AT_WITH_ZONE:
    'DriftChatOpportunityOverview.opportunityCreatedAtWithZone',
  OPPORTUNITY_CLOSED_AT_WITH_ZONE:
    'DriftChatOpportunityOverview.opportunityClosedAtWithZone',
  COUNT: 'DriftChatOpportunityOverview.count',
  DAYS_IN_CYCLE: 'DriftChatOpportunityOverview.opportunityDaysInCycle',
  FIRST_CONVERSATION_CREATED_AT:
    'DriftChatOpportunityOverview.firstConversationCreatedAt',
  DISPLAY_NAME: 'DriftChatOpportunityOverview.firstContactDisplayName',
  LAST_CONVERSATION_ROUTING_OUTCOME:
    'DriftChatOpportunityOverview.lastConversationRoutingOutcome',
  LAST_MEETING_BOOKED_BY_AGENT_DISPLAY_NAME:
    'DriftChatOpportunityOverview.lastMeetingBookedByAgentDisplayName',
}

export const DRIFT_CHAT_OPPORTUNITY_ACTIVITIES = {
  OPPORTUNITY_ID: 'DriftChatOpportunityActivities.opportunityId',
  CONVERSATION_ID: 'DriftChatOpportunityActivities.conversationId',
  ORG_ID: 'DriftChatOpportunityActivities.orgId',
  OPPORTUNITY_DOMAIN: 'DriftChatOpportunityActivities.opportunityDomain',
  END_USER_ID: 'DriftChatOpportunityActivities.endUserId',
  OPPORTUNITY_TYPE: 'DriftChatOpportunityActivities.opportunityType',
  LEAD_CAPTURE_SOURCE: 'DriftChatOpportunityActivities.leadCaptureSource',
  LEAD_CAPTURE_SOURCE_AT: 'DriftChatOpportunityActivities.leadCaptureSourceAt',
  OPPORTUNITY_CREATED_AT: 'DriftChatOpportunityActivities.opportunityCreatedAt',
  OPPORTUNITY_CREATED_AT_WITH_ZONE:
    'DriftChatOpportunityActivities.opportunityCreatedAtWithZone',
  CONVERSATION_CREATED_AT:
    'DriftChatOpportunityActivities.conversationCreatedAt',
  CONVERSATION_UPDATED_AT:
    'DriftChatOpportunityActivities.conversationUpdatedAt',
  CONVERSATION_CREATED_AT_WITH_ZONE:
    'DriftChatOpportunityActivities.conversationCreatedAtWithZone',
  CONVERSATION_UPDATED_AT_WITH_ZONE:
    'DriftChatOpportunityActivities.conversationUpdatedAtWithZone',
}

export const DRIFT_CHAT_OPPORTUNITY_EVENTS = {
  OPPORTUNITY_ID: 'DriftChatOpportunityEvents.opportunityId',
  EVENT_TYPE: 'DriftChatOpportunityEvents.eventType',
  EVENT_DATE_AT: 'DriftChatOpportunityEvents.eventDateAt',
  EVENT_DATE_AT_WITH_ZONE: 'DriftChatOpportunityEvents.eventDateAtWithZone',
  OPPORTUNITY_DOMAIN: 'DriftChatOpportunityEvents.opportunityDomain',
  OPPORTUNITY_TYPE: 'DriftChatOpportunityEvents.opportunityType',
  OPPORTUNITY_CREATED_AT: 'DriftChatOpportunityEvents.opportunityCreatedAt',
  OPPORTUNITY_CREATED_AT_WITH_ZONE:
    'DriftChatOpportunityEvents.opportunityCreatedAtWithZone',
  END_USER_EMAIL: 'DriftChatOpportunityEvents.contactMail',
  END_USER_DISPLAY_NAME: 'DriftChatOpportunityEvents.contactDisplayName',
  AGENT_DISPLAY_NAME:
    'DriftChatOpportunityEvents.meetingBookedByAgentDisplayName',
  AGENT_NAME: 'DriftChatOpportunityEvents.meetingBookedByAgentName',
  LEAD_CAPTURE_SOURCE: 'DriftChatOpportunityEvents.leadCaptureSource',
}

export const DRIFT_CHAT_BIONIC_RATABLE_MESSAGES_DIMENSIONS = {
  CONVERSATION_ID: 'DriftChatBionicRatableMessages.conversationId',
  END_USER_MESSAGE_BODY: 'DriftChatBionicRatableMessages.endUserMessageBody',
  BOT_RESPONSE_MESSAGE_BODY:
    'DriftChatBionicRatableMessages.botResponseMessageBody',
  BOT_RESPONSE_MESSAGE_BODY_HTML:
    'DriftChatBionicRatableMessages.botResponseMessageBodyHtml',
  GEN_AI_RESPONSE_TYPE: 'DriftChatBionicRatableMessages.genAiResponseType',
  BOT_RESPONSE_MESSAGE_ID:
    'DriftChatBionicRatableMessages.botResponseMessageId',
  BOT_RESPONSE_MESSAGE_CREATED_AT:
    'DriftChatBionicRatableMessages.botResponseMessageCreatedAt',
}

export const DRIFT_CHAT_SCENARIO_EXECUTION_DIMENSIONS = {
  SCENARIO_TYPE: 'DriftChatScenarioExecutions.scenarioType',
  SCENARIO_NAME: 'DriftChatScenarioExecutions.scenarioName',
  SCENARIO_ID: 'DriftChatScenarioExecutions.scenarioId',
}

export const DRIFT_CHAT_BIONIC_RATED_MESSAGES_DIMENSIONS = {
  RATED_AT: 'DriftChatBionicRatedMessages.ratedAt',
}

export const DRIFT_CHAT_BIONIC_RATED_MESSAGES_MEASURES = {
  RATINGS_COUNT: 'DriftChatBionicRatedMessages.countRatings',
  RATED_BY_USER_ID: 'DriftChatBionicRatedMessages.ratedByUserId',
}
